import _regeneratorRuntime from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { WebPlugin } from '@capacitor/core';
export var AppWeb = /*#__PURE__*/function (_WebPlugin) {
  _inherits(AppWeb, _WebPlugin);

  var _super = _createSuper(AppWeb);

  function AppWeb() {
    var _this;

    _classCallCheck(this, AppWeb);

    _this = _super.call(this);

    _this.handleVisibilityChange = function () {
      var data = {
        isActive: document.hidden !== true
      };

      _this.notifyListeners('appStateChange', data);
    };

    document.addEventListener('visibilitychange', _this.handleVisibilityChange, false);
    return _this;
  }

  _createClass(AppWeb, [{
    key: "exitApp",
    value: function exitApp() {
      throw this.unimplemented('Not implemented on web.');
    }
  }, {
    key: "getInfo",
    value: function () {
      var _getInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                throw this.unimplemented('Not implemented on web.');

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getInfo() {
        return _getInfo.apply(this, arguments);
      }

      return getInfo;
    }()
  }, {
    key: "getLaunchUrl",
    value: function () {
      var _getLaunchUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", {
                  url: ''
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getLaunchUrl() {
        return _getLaunchUrl.apply(this, arguments);
      }

      return getLaunchUrl;
    }()
  }, {
    key: "getState",
    value: function () {
      var _getState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", {
                  isActive: document.hidden !== true
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getState() {
        return _getState.apply(this, arguments);
      }

      return getState;
    }()
  }]);

  return AppWeb;
}(WebPlugin);